import { render, staticRenderFns } from "./ReportByType.vue?vue&type=template&id=58e85b58&"
import script from "./ReportByType.vue?vue&type=script&lang=js&"
export * from "./ReportByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports